export const GET_EXAM_TYPES = 'GET_EXAM_TYPES'
export const ADD_EXAM_TYPE = 'ADD_EXAM_TYPE'
export const DELETE_SINGLE_EXAM_TYPE = 'DELETE_SINGLE_EXAM_TYPE'
export const DELETE_MANY_EXAM_TYPES = 'DELETE_MANY_EXAM_TYPES'
export const UPDATE_EXAM_TYPE = 'UPDATE_EXAM_TYPE'
export const VIEW_SELECTED_EXAM_TYPE = 'VIEW_SELECTED_EXAM_TYPE'
